module.exports = __webpack_public_path__ + "static/assets/3d1595d862e79cc3ae6b13c2a5be39ea.png";